import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalDangerButtons} from 'components/modals';

const DeleteCycleModal = ({deleteCycle, onCancel, onDelete}) => {
  return (
    <Modal isOpen={deleteCycle !== null} onHide={onCancel} size='sm'>
      <div className="mb1 h3 medium scarlet">
        <FormattedMessage id='performance.Delete Check-In Cycle'/>
      </div>
      <div className="h2 medium mb3">
        <FormattedMessage id='performance.Are you sure you want to delete this check-in cycle?'/>
      </div>
      <ModalDangerButtons onCancel={onCancel} onSave={() => onDelete(deleteCycle)} />
    </Modal>
  );
};

export default DeleteCycleModal;
